module.exports = {
	"id": "SG",
	"name": "Singapore",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016941,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005647,
			"22": 0.022588,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.011294,
			"27": 0.011294,
			"28": 0.005647,
			"29": 0.129881,
			"30": null,
			"31": 0.045176,
			"32": 0.016941,
			"33": 0.028235,
			"34": 0.033882,
			"35": 0.028235,
			"36": 0.016941,
			"37": 0.011294,
			"38": 0.033882,
			"39": 0.073411,
			"40": 0.033882,
			"41": 0.050823,
			"42": 0.090352,
			"43": 0.321879,
			"44": 0.11294,
			"45": 0.158116,
			"46": 0.107293,
			"47": 0.124234,
			"48": 0.333173,
			"49": 1.315751,
			"50": 0.463054,
			"51": 2.140213,
			"52": 0.722816,
			"53": 21.255308,
			"54": 4.794303,
			"55": 0.079058,
			"56": 0.022588,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.039529,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.011294,
			"17": 0.011294,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.005647,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.005647,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.011294,
			"30": 0.011294,
			"31": 0.011294,
			"32": 0.005647,
			"33": 0.011294,
			"34": 0.050823,
			"35": 0.011294,
			"36": 0.011294,
			"37": 0.022588,
			"38": 0.090352,
			"39": 0.022588,
			"40": 0.016941,
			"41": 0.022588,
			"42": 0.022588,
			"43": 0.208939,
			"44": 0.05647,
			"45": 0.220233,
			"46": 0.276703,
			"47": 0.914814,
			"48": 0.491289,
			"49": 4.455483,
			"50": 0.067764,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.011294
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.011294,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.011294,
			"35": 0.005647,
			"36": 0.016941,
			"37": 0.05647,
			"38": 0.321879,
			"39": 0.028235,
			"40": 0.248468,
			"41": 0.039529,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.022588
		},
		"safari": {
			"0": null,
			"4": 0.084705,
			"5": 0.033882,
			"6": 0.011294,
			"7": 0.050823,
			"8": 0.299291,
			"9": 0.304938,
			"10": 1.705394,
			"3.1": null,
			"3.2": null,
			"5.1": 0.079058,
			"6.1": 0.073411,
			"7.1": 0.011294,
			"9.1": 1.321398
		},
		"ios_saf": {
			"8": 0,
			"10": 10.8493940033,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.29237861428,
			"8.1-8.4": 0.540157100958,
			"9.0-9.2": 0.257689626145,
			"9.3": 3.93141865529
		},
		"android": {
			"3": 0,
			"4": 0.0288962713178,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00361203391473,
			"4.1": 0.104232978682,
			"4.2-4.3": 0.260582446705,
			"4.4": 0.597533610465,
			"4.4.3-4.4.4": 0.602693658915
		},
		"ie": {
			"6": 0.0373151193182,
			"7": 0.0435343058712,
			"8": 1.13189195265,
			"9": 0.317178514205,
			"10": 0.491315737689,
			"11": 4.53378699716,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0399258544955,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00110905151376
		},
		"edge": {
			"12": 0.084705,
			"13": 0.474348,
			"14": 1.315751
		},
		"ie_mob": {
			"10": 0.0291834929577,
			"11": 0.118818507042
		},
		"bb": {
			"7": 0.026118,
			"10": null
		},
		"samsung": {
			"0": 5.454309
		},
		"and_uc": {
			"0": 4.13535
		},
		"op_mini": {
			"0": 0.537914093991
		},
		"and_chr": {
			"0": 17.386303
		},
		"and_ff": {
			"0": 0.047883
		}
	},
	"total": 98.1285136269
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SG.json
 ** module id = 642
 ** module chunks = 0
 **/